import { useSlots, computed, openBlock, createElementBlock, normalizeClass, renderSlot, createBlock, createCommentVNode } from "vue";
import WarningIcon from "../uikit.icons/WarningIcon.vue.es.js";
import ErrorIcon from "../uikit.icons/ErrorIcon.vue.es.js";
/* empty css              */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _hoisted_1 = {
  key: 0,
  class: "icon"
};
const _sfc_main = {
  __name: "Infos",
  props: {
    type: {
      type: String,
      validator(value) {
        return ["infos", "success", "warning", "error"].includes(value);
      },
      default: "infos"
    },
    noIcon: {
      type: Boolean,
      default: false
    }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const slots = useSlots();
    const props = __props;
    const infosClasses = computed(() => {
      return {
        [`uikit-infos-${props.type}`]: true
      };
    });
    const isWarning = computed(() => {
      return props.type === "warning";
    });
    const isError = computed(() => {
      return props.type === "error";
    });
    const isInfo = computed(() => {
      return props.type === "infos";
    });
    const hasIcon = computed(() => {
      return !props.noIcon && (slots.icon !== void 0 || isWarning.value || isError.value || isInfo.value);
    });
    const handleClick = () => {
      emit("click");
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(["uikit-infos", infosClasses.value]),
        onClick: handleClick
      }, [
        hasIcon.value ? (openBlock(), createElementBlock("span", _hoisted_1, [
          renderSlot(_ctx.$slots, "icon", {}, () => [
            isWarning.value ? (openBlock(), createBlock(WarningIcon, { key: 0 })) : createCommentVNode("", true),
            isError.value || isInfo.value ? (openBlock(), createBlock(ErrorIcon, { key: 1 })) : createCommentVNode("", true)
          ], true)
        ])) : createCommentVNode("", true),
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 2);
    };
  }
};
const Infos = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-25291462"]]);
export {
  Infos as default
};
//# sourceMappingURL=Infos.vue.es.js.map
